export const enum AuditEvent {

    NONE = -1,
    Requested          = 0,
    Approved           = 1,
    Rejected           = 2,
    Saved              = 4,
    Payment_Inititated = 3
}

export interface ClaimAudit {

    description: string,
    username:    string | null,
    timestamp:   Date,
    action:      AuditEvent
}